import { Tooltip } from "@material-ui/core";

interface LongTextProps {
  text: string;
  length?: number;
}

export const LongText = ({ text, length = 60 }: LongTextProps) => (
  <Tooltip title={<h3>{text}</h3>}>
    <span>{text.length > length ? `${text.substring(0, length)}...` : text}</span>
  </Tooltip>
);
